import { ICopyMenuModalState } from './copyMenuModalContext';
import { CopyMenuModalActionTypes, TCopyMenuModalAction } from '../copyMenuModalActions';

export const copyMenuModalReducer = (state: ICopyMenuModalState, action: TCopyMenuModalAction): ICopyMenuModalState => {
	switch (action.type) {
		case CopyMenuModalActionTypes.SET_IDS_RESTAURANTS_TO_COPY_MENU:
			return {
				...state,
				IDsSelectedRestaurantsToCopyMenu: action.payload.IDsSelectedRestaurantsToCopyMenu,
			};
		case CopyMenuModalActionTypes.CHANGE_TYPE_OF_COPY_MENU_MODAL_WINDOW:
			return {
				...state,
				typeOfCopyMenuModalWindow: action.payload.typeOfCopyMenuModalWindow,
			};
		default:
			return state;
	}
};
